export const qualitie = ['BIO', 'Best Beef', 'GQ', 'GVO', 'QM', 'QS'];
